import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";

export function SalesTimelineChart({ data }) {
  if (!data || data.length === 0) {
    return <p className="text-[#5A6B85] text-sm py-10 text-center" data-testid="timeline-empty">Nessun dato di andamento disponibile.</p>;
  }
  return (
    <div className="h-64 w-full min-h-[256px]" data-testid="sales-timeline-chart">
      <ResponsiveContainer width="100%" height="100%" minHeight={256}>
        <LineChart data={data} margin={{ top: 10, right: 16, left: -8, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(15,30,51,0.08)" />
          <XAxis dataKey="date" stroke="#5A6B85" fontSize={12} tickLine={false} axisLine={{ stroke: "#DCE7F5" }} />
          <YAxis yAxisId="left" stroke="#5A6B85" fontSize={12} tickLine={false} axisLine={false} allowDecimals={false} />
          <YAxis yAxisId="right" orientation="right" stroke="#0B6BCB" fontSize={12} tickLine={false} axisLine={false} />
          <Tooltip
            contentStyle={{ background: "#FFFFFF", border: "1px solid #DCE7F5", borderRadius: 8, color: "#0F1E33" }}
            formatter={(value, name) => (name === "Premio €" ? [`€ ${Number(value).toLocaleString("it-IT")}`, name] : [value, name])}
          />
          <Legend wrapperStyle={{ fontSize: 12, color: "#5A6B85" }} />
          <Line yAxisId="left" type="monotone" dataKey="vendite" name="Vendite" stroke="#5A6B85" strokeWidth={2} dot={{ r: 3, fill: "#5A6B85" }} activeDot={{ r: 5 }} />
          <Line yAxisId="right" type="monotone" dataKey="premio" name="Premio €" stroke="#0B6BCB" strokeWidth={2.5} dot={{ r: 3, fill: "#0B6BCB" }} activeDot={{ r: 5 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
